import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import './ProgressBar.scss';

class ProgressBar extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showMessaging: false
    };
    this.timeout = null;
  }

  static getDerivedStateFromProps(props, state) {
    const active = props.active;
    return active !== state.showMessaging ? { showMessaging: active } : null;
  }

  render() {
    return (
      <div className="cp-progress-bar">
        <div className={`bar ${this.props.active ? 'active' : ''}`} />
        <ScreenReaderMessage aria-live="polite" aria-atomic="true" role="region">
          {this.state.showMessaging && <FormattedMessage id="ada_results_updated" />}
        </ScreenReaderMessage>
      </div>
    );
  }
}

ProgressBar.propTypes = {
  active: PropTypes.bool
};

export default ProgressBar;
